export default __webpack_public_path__ + "static/media/cms-light.f0288532.png";